<template>
  <ValidationObserver v-slot="{handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal :visible="modal.show"
                   :title="$t('Increments')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <increment-tiers :model="model" attribute="increments"/>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import IncrementTiers from "@/core/components/increment-tiers/IncrementTiers";
  import Increment from "@/core/components/increment-tiers/Increment.model";
  import IncrementsModel from "@/core/components/increment-tiers/incrementsModel.model";

  const {mapState, mapActions} = createNamespacedHelpers('reservations');

  export default {
    name: "IncrementsModal",
    components: {IncrementTiers, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new IncrementsModel(),
      }
    },
    methods: {
      ...mapActions(['toggleIncrementsModal', 'postIncrements']),
      async onSubmit() {
        let requestData = this.model.increments.map(increment => {
          return {...increment.toJSON(), auction_uuid: this.auction_uuid}
        });

        this.loading = true;
        let response = await this.postIncrements(requestData);
        this.loading = false;

        if (response.success) {
          this.$toast('success', this.$t('Increments were successfully saved'));
          await this.toggleIncrementsModal(false);
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            for (let index in response.body) {
              this.model.increments[index].setMultipleErrors(response.body[index]);
            }
          }
        }
      },
      onShow() {
        this.initIncrements();
      },
      onHidden() {
        this.model = new IncrementsModel();
        this.toggleIncrementsModal(false);
      },
      initIncrements() {
        this.model = new IncrementsModel({increments: this.increments.map(data => new Increment(data))});
      },
    },
    watch: {
      increments() {
        this.initIncrements();
      }
    },
    computed: {
      ...mapState({
        modal: state => state.view.incrementsData.modal,
        increments: state => state.view.incrementsData.increments,
        auction_uuid: state => state.view.currentReservation.auction_uuid
      }),
    },
  }
</script>

<style lang="scss" scoped>
</style>

